import { newFileInfraModuleProviders } from './upload-v2/providers';
import { DynamicUploadComponent } from './upload.component';
import { EnvironmentProviders, NgModule, Provider } from '@angular/core';
import { getFlag } from '@app/shared/utils/flag';

export { FILE_SERVICE_V2 } from './upload-v2/file-service.token';

export const getProviders = (): (Provider | EnvironmentProviders)[] =>
	getFlag('enableNewFileInfra') ? newFileInfraModuleProviders : [];

export const importUploadComponent = () =>
	getFlag('enableNewFileInfra')
		? import('./upload-v2/upload.component')
		: import('./upload-legacy/upload.component');
@NgModule({
	imports: [DynamicUploadComponent],
	providers: getProviders(),
	exports: [DynamicUploadComponent],
})
export class DynamicUploadModule implements NgModule {
	constructor() {
		// Preload the upload component based on the feature flag.
		// This will ensure that the component is loaded when the module is imported, and not pop-in after a slight delay upon rendering.
		void importUploadComponent();
	}
}
